<template>
  <div class="card width-340">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <div class="center mgb-20px">
        <div class="columns">
          <div class="column">
            <h1 class="title is-size-4">
              {{ $t('listeEcheancesAPayer.popUpReplanification.title') }}
            </h1>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div>
        <b-field :label="$t('listeEcheancesAPayer.popUpReplanification.date')">
          <b-datepicker show-week-number
                        nearby-selectable-month-days
                        icon="calendar-today"
                        v-model="newDate"
                        :editable="true">
          </b-datepicker>
        </b-field>
        <b-field :label="$t('listeEcheancesAPayer.popUpReplanification.commentaire')">
          <b-input v-model="commentaire" type="textarea" :rows="2" custom-class="max-height-80">
          </b-input>
        </b-field>
      </div>
      <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('listeEcheancesAPayer.popUpReplanification.actions.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="updateEcheance()">
              {{ $t('listeEcheancesAPayer.popUpReplanification.actions.validate')}}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import { replanificationEcheanceAPayer } from '@/api/echeancierContrat';
import formatIsoDate from '@/services/general/formatIsoDate';
import messageErreur from '@/services/general/messageErreur';
import validation from '@/services/validation/validation';
import translate from '@/services/baux/echeancesAPayer/translatorEcheancesAPayer';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  props: {
    echeancesAPayer: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      newDate: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      commentaire: null,
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    async updateEcheance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await replanificationEcheanceAPayer({
          echeancesAPayerIds: this.echeancesAPayer.map((el) => { return el.id; }),
          datePlanification: formatIsoDate(this.newDate),
          commentaire: this.commentaire,
        });
        this.$emit('replanificationOk');
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response && e.response.data.error.validationErrors) {
          this.messages = [];
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
};
</script>

<style scoped>

</style>
